import wretch from "wretch";

const apiClient = wretch().options({ credentials: "same-origin" });

export function subscribeToMailchimp(body) {
  const client = apiClient.url("/front-end/subscribe");
  return client.post(body).json();
}
